module.exports = __webpack_public_path__ + "img/ck@2x.b34f2fee.png";